/* eslint-disable no-unused-vars */
/* eslint-disable react/no-array-index-key */
import React, { useState, useEffect, useContext } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import AppAlert from '../../../shared/components/app-alert/AppAlert';
import AppLoading from '../../../shared/components/app-loading/AppLoading';
import NoSearchResults from '../../one-way/NoSearchResults';
import './BusBookingDetails.scss';
import {
  GENDER_OPTIONS_DICT,
  NAVIGATION_ROUTES,
  STATUS_OPTIONS_DICT,
} from '../../../shared/constants/Constants';
// import AppModal from '../../../shared/components/app-modal/AppModal';
import {
  cancelBusBookingApi,
  getBusBookingDetailsApi,
} from '../../../api/busApi';
import BookingDetails from './BookingDetails';
import AppButton from '../../../shared/components/app-button/AppButton';
import { AppConfirmationContext } from '../../../shared/components/app-confirmation/AppConfirmationProvider';

function BusBookingCancellationPage() {
  const { transactionId } = useParams();
  const [isLoading, setLoading] = useState(false);
  const [alert, setAlert] = useState(undefined);
  const [bookingDetails, setBookingDetails] = useState({});
  const [isSearchDone, setSearchDone] = useState(false);
  // const [confirmationDialogOpen, setConfirmationDialogOpen] = useState(false);
  const [selectedSeats, setSelectedSeats] = useState([]);
  const navigate = useNavigate();
  const { showAppConfirmationDialog } = useContext(AppConfirmationContext);

  const getBusBookingDetails = async () => {
    setLoading(true);
    const response = await getBusBookingDetailsApi(transactionId);
    if (response?.Root?.Status === 'OK') {
      const data = response.Root?.Result?.BusInvoice || {};
      if (data.BusPassengers && data.BusPassengers.BusPassenger) {
        data.BusPassengers.BusPassenger = Array.isArray(
          data.BusPassengers.BusPassenger,
        )
          ? data.BusPassengers.BusPassenger
          : [data.BusPassengers.BusPassenger];
      } else {
        data.BusPassengers.BusPassenger = [
          {
            Title: data.PaxSalutation,
            FirstName: data.PaxFirstName,
            LastName: data.PaxLastName,
            SeatNumber: data.SeatsSelected,
            Age: data.PaxAge,
            Gender: data.PaxGender,
            Status: data.TicketStatus,
          },
        ];
      }
      setBookingDetails(data);
      setSearchDone(true);
    } else {
      setAlert({
        variant: 'error',
        title: 'Bus Bookings Details',
        description: response?.Root?.Message,
      });
    }
    setLoading(false);
  };

  useEffect(() => {
    getBusBookingDetails();
  }, []);

  const getFullName = (item) => {
    let name = '';
    if (item.Title) name += item.Title;
    if (item.FirstName) name += ` ${item.FirstName}`;
    if (item.LastName) name += ` ${item.LastName}`;
    return name;
  };

  const handlePaxSelection = (paxIndex) => {
    const list = [...bookingDetails.BusPassengers.BusPassenger];
    const selectedList = [...selectedSeats];
    const index = selectedList.findIndex(
      (d) => d === list[paxIndex].SeatNumber,
    );
    if (index !== -1) {
      selectedList.splice(index, 1);
    } else {
      selectedList.push(list[paxIndex].SeatNumber);
    }
    setSelectedSeats(selectedList);
  };

  const onBookingCancel = () => {
    showAppConfirmationDialog(
      `Cancel Booking`,
      `Are you sure, Do you want to cancel this booking?`,
      async () => {
        setLoading(true);
        const response = await cancelBusBookingApi(
          transactionId,
          selectedSeats.join(','),
        );
        setLoading(false);
        if (response && response.Root && response.Root.Status === 'OK') {
          setAlert({
            variant: 'success',
            title: 'Booking cancellation Success',
            description: `${
              response.Root?.Message ? response.Root?.Message : ''
            } 
              You have successfully cancelled the ticket, Redirecting to my booking page...`,
          });
          setTimeout(() => {
            navigate(
              `${NAVIGATION_ROUTES.MY_BOOKINGS_ROUTE}?transactionType=busBookings`,
            );
          }, 2000);
        } else {
          setAlert({
            variant: 'error',
            title: 'Booking Cancellation Failed',
            description: response.Root?.Message,
          });
        }
      },
    );
  };

  return (
    <section className="pt-3">
      <section className="app-container">
        <section className="view-booking-details-page">
          <AppLoading isLoading={isLoading} />
          {alert && (
            <AppAlert
              showIcon
              variant={alert.variant}
              title={alert.title}
              onHide={() => setAlert(undefined)}
              description={alert.description}
            />
          )}
          {isSearchDone && (
            <>
              <div className="view-booking-details-page__header">
                <span>Bus Booking Cancellation</span>
                <span className="primary-color">{transactionId}</span>
              </div>
              <div className="separator" />
              {Object.keys(bookingDetails).length > 0 ? (
                <>
                  <BookingDetails bookingDetails={bookingDetails} />
                  <div className="separator" />
                  <div className="view-booking-details-page_passenger-details">
                    <Row className="spacing-16">
                      <Col lg={12}>
                        <Row className="spacing-16">
                          <Col lg={1} md={1} sm={1}>
                            <span className="passenger-label">Select</span>
                          </Col>
                          <Col lg={3} md={3} sm={3}>
                            <span className="passenger-label">
                              Passenger Name
                            </span>
                          </Col>
                          <Col lg={2} md={2} sm={2}>
                            <span className="passenger-label">Seat Number</span>
                          </Col>
                          <Col lg={2} md={2} sm={2}>
                            <span className="passenger-label">Gender</span>
                          </Col>
                          <Col lg={2} md={2} sm={2}>
                            <span className="passenger-label">Age</span>
                          </Col>
                          <Col lg={2} md={2} sm={2}>
                            <span className="passenger-label">Status</span>
                          </Col>
                        </Row>
                      </Col>
                      <Col lg={12}>
                        <Row className="spacing-16">
                          {bookingDetails.BusPassengers.BusPassenger.map(
                            (d, index) => (
                              <Col lg={12} key={index}>
                                <Row className="spacing-16">
                                  <Col lg={1} md={1} sm={1}>
                                    <input
                                      type="checkbox"
                                      onChange={() => handlePaxSelection(index)}
                                    />
                                  </Col>
                                  <Col lg={3} md={3} sm={3}>
                                    <span className="passenger-value">
                                      {getFullName(d)}
                                    </span>
                                  </Col>
                                  <Col lg={2} md={2} sm={2}>
                                    <span className="passenger-value">
                                      {d.SeatNumber || '-'}
                                    </span>
                                  </Col>
                                  <Col lg={2} md={2} sm={2}>
                                    <span className="passenger-value">
                                      {d.Gender
                                        ? GENDER_OPTIONS_DICT[
                                            d.Gender.toLowerCase()
                                          ]
                                        : '-'}
                                    </span>
                                  </Col>
                                  <Col lg={2} md={2} sm={2}>
                                    <span className="passenger-value">
                                      {d.Age || '-'}
                                    </span>
                                  </Col>
                                  <Col lg={2} md={2} sm={2}>
                                    <span className="passenger-value green-color">
                                      {d.Status
                                        ? STATUS_OPTIONS_DICT[
                                            d.Status.toLowerCase()
                                          ]
                                        : '-'}
                                    </span>
                                  </Col>
                                </Row>
                              </Col>
                            ),
                          )}
                        </Row>
                      </Col>
                    </Row>
                  </div>
                  <div className="separator" />
                  <div className="d-flex justify-content-center p-3">
                    <AppButton
                      variant="primary"
                      btnText="Cancel"
                      onClick={onBookingCancel}
                      disabled={selectedSeats.length === 0}
                    />
                  </div>
                </>
              ) : (
                <NoSearchResults />
              )}
            </>
          )}
        </section>
      </section>
    </section>
  );
}

BusBookingCancellationPage.defaultProps = {};

BusBookingCancellationPage.propTypes = {};

export default BusBookingCancellationPage;
